import React from 'react'
import PropTypes from 'prop-types'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from './msal-instance'

const LoginMsalProvider = ({ children }) => {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
}

export default LoginMsalProvider

LoginMsalProvider.propTypes = {
  children: PropTypes.node,
}
